import type {
  AuthorPortfolioAsset,
  PortfolioAssetItem,
  PortfolioRow,
} from '@/modules/Author/interface/Author';
import type {
  SearchPortfolioAsset,
  SearchPortfolioAssetItem,
} from '@/modules/Search/interface/Search';
import { normalizeString } from './string';

const redFlags = ['vender', 'venda'];
const greenFlags = ['comprar', 'compra', 'aberto'];

export const getTableHeads = (assets: Asset[]) => {
  if (!assets) return [];
  return assets.map(({ label }) => ({
    cell: normalizeString(label) === normalizeString('imagem') ? ' ' : label,
  }));
};

export const getTableRows = (assets: Asset[]) => {
  if (!assets) return [];
  const rows = [] as PortfolioRow[];

  assets.forEach((asset, assetIndex) => {
    asset?.itens.map((item, index) => {
      const isImageCell =
        normalizeString(asset?.label) === normalizeString('imagem');

      const cell = {
        value: mountCellValue(isImageCell, item),
        thumb: isImageCell && 'thumb' in item ? item.thumb : null,
        styleProps: getTableCellClass(asset, assetIndex, item),
        asset_id: 'asset_id' in item ? (item.asset_id ?? null) : null,
        asset_name: mountAssetName(item),
      };

      if (!rows[index]) {
        rows[index] = { cells: [] };
      }
      rows[index].cells.push(cell);
    });
  });

  return rows;
};

const mountCellValue = (isImageCell: boolean, item: AssetItem) => {
  if (isImageCell) {
    return ' ';
  }
  if ('name' in item && item.name) {
    return item.name;
  }
  return item.item;
};

const mountAssetName = (item: AssetItem) => {
  if ('name' in item && 'asset_id' in item && item?.asset_id && item?.brapi) {
    return item.name;
  }
  return item?.item ?? null;
};

export const getTableCellClass = (
  asset: Asset,
  index: number,
  item: AssetItem
) => {
  const bolder =
    (index === 0 || index === 1) &&
    ['imagem', 'ticker'].includes(normalizeString(asset?.label));

  if (bolder || ('brapi' in item && item?.brapi)) {
    return { fontWeight: 'bold', color: 'content.primary' };
  }

  const name = (
    'name' in item && item?.name ? item.name : item?.item
  )?.toLowerCase();

  if (!name) {
    return { fontWeight: 'normal', color: 'content.primary' };
  }

  if (redFlags.includes(name)) {
    return { fontWeight: '600', color: 'alert.error' };
  }

  if (greenFlags.includes(name)) {
    return {
      fontWeight: '600',
      color: 'alert.success',
      textTransform: 'uppercase' as const,
    };
  }

  if (name.includes('%')) {
    if (name.includes('-')) {
      return {
        fontWeight: 'normal',
        color: 'alert.error',
        textTransform: 'uppercase' as const,
      };
    }
    return {
      fontWeight: 'normal',
      color: 'alert.success',
      textTransform: 'uppercase' as const,
    };
  }

  return { fontWeight: 'normal', color: 'content.primary' };
};

type AssetItem =
  | PortfolioAssetItem
  | Pick<PortfolioAssetItem, 'item'>
  | Partial<SearchPortfolioAssetItem>;

type Asset = AuthorPortfolioAsset | SearchPortfolioAsset;

export type CellDataProps = {
  value: string;
  thumb: string | null;
  class: string;
  asset_id: string | null;
  asset_name: string | null;
};
